import { TileContent } from 'components/Layout/PageContainer';
import { MetricsLoadingSpinner } from 'components/MetricsLoadingSpinner';
import { ReactNode, useEffect, useRef, useState } from 'react';
import { EmptyState } from 'components/EmptyState';
import { TbIcon } from 'components/Figma';
import { Button } from 'components/Button';

interface ProductsListProps {
  list: ReactNode[] | undefined;
}
export function Carousel({ list }: ProductsListProps) {
  const [showLeftScrollButton, setShowLeftScrollButton] = useState(false);
  const [showRightScrollButton, setShowRightScrollButton] = useState(false);

  const scrollRef = useRef<HTMLDivElement>(null);
  const exampleCarouselItem = useRef<HTMLDivElement>(null);

  const scrollStep = exampleCarouselItem.current ? exampleCarouselItem.current.offsetWidth : 0;
  const scrollToRight = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: scrollStep,
        behavior: 'smooth',
      });
    }
  };
  const scrollToLeft = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: -scrollStep,
        behavior: 'smooth',
      });
    }
  };
  const checkScrollPosition = () => {
    if (scrollRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = scrollRef.current;
      const threshold = 1; // Account for pixel rounding errors
      const isAtLeft = scrollLeft <= threshold;
      const isAtRight = scrollLeft + clientWidth >= scrollWidth - threshold;
      setShowLeftScrollButton(!isAtLeft);
      setShowRightScrollButton(!isAtRight);
    }
  };
  useEffect(() => {
    const container = scrollRef.current;
    container?.addEventListener('scroll', checkScrollPosition);
    window.addEventListener('resize', checkScrollPosition);
    setTimeout(checkScrollPosition, 100);
    return () => {
      container?.removeEventListener('scroll', checkScrollPosition);
      window.removeEventListener('resize', checkScrollPosition);
    };
  }, [checkScrollPosition]);
  if (!list) {
    return <MetricsLoadingSpinner />;
  }
  if (list.length === 0) {
    return <EmptyState />;
  }
  return (
    <TileContent className="relative" data-testid="arousel">
      <div className="no-scrollbar flex flex-row items-start overflow-hidden overflow-x-clip py-3" ref={scrollRef}>
        {list.map((entry, idx) => {
          return (
            <div
              ref={idx === 0 ? exampleCarouselItem : undefined}
              key={`Item${idx}`}
              className="relative bg-snow-50 h-fit w-fit  hover:bg-snow-100 transition"
            >
              {entry}
            </div>
          );
        })}
      </div>
      {showLeftScrollButton ? (
        <Button
          onClick={e => {
            e.stopPropagation();
            scrollToLeft();
          }}
          priority="secondary"
          size="sm"
          className="absolute z-20 top-1/3"
        >
          <TbIcon name="ChevronLeft" />
        </Button>
      ) : (
        ''
      )}
      {showRightScrollButton ? (
        <Button
          priority="secondary"
          size="sm"
          onClick={e => {
            e.stopPropagation();
            scrollToRight();
          }}
          className="absolute z-20 top-1/3 right-0"
        >
          <TbIcon name="ChevronRight" />
        </Button>
      ) : (
        ''
      )}
    </TileContent>
  );
}
